import { computed } from "vue";
import useCreateComponentConfig, { EStates, EVariants } from "../../../composables/useCreateComponentConfig.js";
import focus from "../../constants/focus.js";
import { SIZES } from "@/ui/ts/types/Sizes";
var ELinkElements = /* @__PURE__ */ ((ELinkElements2) => {
  ELinkElements2["ROOT"] = "ROOT";
  return ELinkElements2;
})(ELinkElements || {});
export default function useLinkConfig(props) {
  const { setBase, addBaseState, addSize, setDefault, getClasses } = useCreateComponentConfig();
  setBase(
    "ROOT" /* ROOT */,
    /* tw */
    `!font-semibold max-w-fit border-radius-button p-0 gap-2xs flex flex-row items-center !underline transition-colors duration-200 ease-linear delay-0`
  );
  addBaseState(
    "ROOT" /* ROOT */,
    EStates.DEFAULT,
    /* tw */
    `text-comp-high-contrast`
  );
  addBaseState(
    "ROOT" /* ROOT */,
    EStates.HOVER,
    /* tw */
    `hover:text-comp-high-contrast-hover`
  );
  addBaseState(
    "ROOT" /* ROOT */,
    EStates.DISABLED,
    /* tw */
    `pointer-events-none select-none text-disabled border-disabled !cursor-not-allowed`
  );
  addBaseState("ROOT" /* ROOT */, EStates.FOCUSED, `${focus}`);
  addBaseState(
    "ROOT" /* ROOT */,
    EStates.PRESSED,
    /* tw */
    `active:text-comp-high-contrast-pressed`
  );
  addSize(
    "ROOT" /* ROOT */,
    SIZES.XSMALL,
    /* tw */
    `label-xs`
  );
  addSize(
    "ROOT" /* ROOT */,
    SIZES.SMALL,
    /* tw */
    `label-sm`
  );
  addSize(
    "ROOT" /* ROOT */,
    SIZES.MEDIUM,
    /* tw */
    `label-md`
  );
  addSize(
    "ROOT" /* ROOT */,
    SIZES.LARGE,
    /* tw */
    `label-lg`
  );
  setDefault("ROOT" /* ROOT */, EVariants.DEFAULT, props.size ?? SIZES.LARGE);
  const rootClasses = computed(() => {
    return getClasses("ROOT" /* ROOT */, void 0, props.size, void 0, props.disabled);
  });
  return {
    rootClasses: rootClasses.value
  };
}
